import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectChosenPlan, selectHasFiber } from '../../../../redux';
import TitleAddOns from '../TitleAddOns';
import DownloadSpeedCharacteristic from './DownloadSpeedCharacteristic';
import { showTitleAddons } from '../../../../utils';

const FiberCharacteristics = () => {
  const { t } = useTranslation('ChangePlan');
  const selectedPlan = useSelector(selectChosenPlan);
  const { characteristics } = selectedPlan;

  if (!characteristics.downloadSpeed) {
    return null;
  }

  const downloadUnits = characteristics.downloadUnits || t('plan.primaryAttribute.downloadSpeeds.units');

  return <DownloadSpeedCharacteristic downloadSpeed={characteristics.downloadSpeed} downloadUnits={downloadUnits} />;
};

const SatelliteCharacteristics = () => {
  const selectedPlan = useSelector(selectChosenPlan);
  const { characteristics } = selectedPlan;

  const showTitleAddOns = showTitleAddons(
    characteristics.productFamily,
    characteristics.offerName,
    characteristics.titleAddOns
  );

  if (!showTitleAddOns) {
    return null;
  }

  return (
    <div>
      <TitleAddOns characteristic={characteristics.titleAddOns} showIcon={true} />
    </div>
  );
};

export const Characteristics = () => {
  const isFiber = useSelector(selectHasFiber);
  return isFiber ? <FiberCharacteristics /> : <SatelliteCharacteristics />;
};
